import styled, { css } from 'styled-components';
import { getColor } from 'common/constants/_colors';
import { lightColorPalette } from '@linearb/linui-common';

export const HighlightStyle = `
  box-shadow: 0px 0px 34px rgba(59, 89, 152, 0.24);
  transition: box-shadow 0.5s ease-in-out;
`;

export const tableNoBorderStyle = `
  .MuiTableHead-root > .MuiTableRow-head:first-child {
    border-top: 0;
  }

  .MuiTableHead-root .MuiTableCell-head {
    border-left: 0px;
    border-right: 0px;
  }

  .MuiTableBody-root .MuiTableCell-body {
    border-left: 0px;
    border-right: 0px;
  }

  .MuiTableCell-root {
    border: 0px;
  }
`;

export const ClickableTextMixin = css`
  ${p =>
    p.onClick &&
    `
    &:hover{
      cursor: pointer;
      opacity: 0.7;
    };
  `}
`;

const LINK_COLOR = getColor('dodgerBlue');

export const StyledLink = styled.a`
  ${({ href }) =>
    href &&
    `
    color: ${LINK_COLOR};
    text-decoration: none;
    &:hover {
      cursor: pointer;
      opacity: 0.7;
    }
  `}
`;

export const cssWhiteSection = css`
  box-sizing: border-box;
  background: ${getColor('white')};
  padding: 2rem;
  border-radius: 2px;
  display: block;
`;

export const StyledWidgetHeader = styled.div`
  text-transform: capitalize;
  font-size: 1.4rem;
  color: ${getColor('shark')};
  text-align: start;
  font-weight: normal;
  font-style: normal;
  text-decoration: none;
  line-height: 2rem;
  letter-spacing: normal;
`;

export const CHART_LEGEND_ITEM_STYLE = {
  textTransform: 'capitalize',
  color: lightColorPalette.lbTextSubdued,
  fontWeight: 'normal'
};

export const STICKY_OFFSET = 0.1; // rem
